import { render, staticRenderFns } from "./VPSSecurityProfileSQAEdit.vue?vue&type=template&id=2e40f027&scoped=true"
import script from "./VPSSecurityProfileSQAEdit.vue?vue&type=script&lang=js"
export * from "./VPSSecurityProfileSQAEdit.vue?vue&type=script&lang=js"
import style0 from "./VPSSecurityProfileSQAEdit.vue?vue&type=style&index=0&id=2e40f027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e40f027",
  null
  
)

export default component.exports